import { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import Link from 'components/link'
import { helloBabyPostPath } from 'lib/urls'
import css from './hero-post.scss'

class HeroPost extends Component {
  static defaultProps = {
    navigateWithRouter: true,
  }

  render() {
    let { post, navigateWithRouter } = { ...this.props }
    const navigationProp = {
      [!navigateWithRouter ? 'url' : 'to']: helloBabyPostPath(
        post && post.slug
      ),
    }
    return (
      <div key={4123} className={classNames(css.heroPostContainer)}>
        <div
          style={{ backgroundImage: 'url(' + post.featuredImage?.url + ')' }}
          className={classNames(
            css.featuredImage,
            'hover-overlay hover-lighten'
          )}
        ></div>
        <div className={classNames(css.postInfo, 'flex-vertical-center')}>
          <div>
            <Link
              className={classNames(css.postTitle, 'h3', 'text-body')}
              {...navigationProp}
            >
              {post.title}
            </Link>
            <p className={classNames(css.textSerifGuides, 'mbn')}>
              {post.teaser}
            </p>
          </div>
        </div>
      </div>
    )
  }
}

HeroPost.propTypes = {
  post: PropTypes.object.isRequired,
}

export default HeroPost
